export const totalFriendsRequired = 4;
